import assetPath from '/app/xinglets/startpage-logged-out/entry/src/recruiters-section/assets/malte-balmer.256x256.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')